import type { SVGProps } from 'react';

interface PrizeIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const PrizeIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & PrizeIconProps) => (
  <svg
    {...props}
    aria-describedby={descId}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 16 17"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#prize_svg__a)">
      <path
        d="M7.438 9.25V16h-3A2.437 2.437 0 0 1 2 13.563V9.25zm6.562 0v4.313A2.437 2.437 0 0 1 11.563 16h-3V9.25zM9.875 1a2.437 2.437 0 0 1 2.053 3.752l1.884-.002c.518 0 .938.35.938.782v2.186c0 .432-.42.782-.937.782h-5.25V4.75H7.437V8.5h-5.25c-.517 0-.937-.35-.937-.782V5.533c0-.433.42-.782.938-.782l1.884.002A2.437 2.437 0 0 1 8 1.88 2.43 2.43 0 0 1 9.875 1m-3.75 1.125a1.312 1.312 0 0 0-.108 2.62l.108.005h1.313V3.438l-.005-.109a1.31 1.31 0 0 0-1.308-1.204m3.75 0a1.313 1.313 0 0 0-1.312 1.313V4.75h1.312a1.313 1.313 0 0 0 0-2.625"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="prize_svg__a">
        <path d="M0 .5h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
